export const pendoToken = Symbol('pendo');
